(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const headerSection = document.querySelector('.section-header');
    if (!headerSection) return;

    /* ----- Hauteur pour --header-height (héros etc.) ----- */
    const updateHeaderHeight = () => {
      document.documentElement.style.setProperty(
        '--header-height',
        `${headerSection.offsetHeight}px`
      );
    };

    /* ----- Gestion du scroll (classe scrolled-past-header) ----- */
    const updateScrollState = () => {
      const y = window.pageYOffset || document.documentElement.scrollTop;
      if (y > 10) {
        headerSection.classList.add('scrolled-past-header');
      } else {
        headerSection.classList.remove('scrolled-past-header');
      }
    };

    /* ----- MEGA MENU : ajoute .mega-open quand un <details> est ouvert ----- */
    const detailsEls = headerSection.querySelectorAll('details');
    const updateMegaState = () => {
      let anyOpen = false;
      detailsEls.forEach(d => {
        if (d.open) anyOpen = true;
      });
      headerSection.classList.toggle('mega-open', anyOpen);
    };

    detailsEls.forEach(d => {
      d.addEventListener('toggle', updateMegaState);
    });

    // init au chargement
    updateHeaderHeight();
    updateScrollState();
    updateMegaState();

    window.addEventListener(
      'scroll',
      () => {
        window.requestAnimationFrame(updateScrollState);
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      () => {
        window.requestAnimationFrame(updateHeaderHeight);
      }
    );
  });

  } catch(e) { console.error(e); }
})();
})();
